import { render } from "./RightsTable.vue?vue&type=template&id=a2876432"
import script from "./RightsTable.vue?vue&type=script&lang=ts"
export * from "./RightsTable.vue?vue&type=script&lang=ts"
script.render = render

export default script